module.exports = __webpack_public_path__ + "media/passeggiata.db254b09.svg";